import { render } from "./InvEstmentportfolio.vue?vue&type=template&id=56bad9e4"
const script = {}

import exportComponent from "../../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/InvEstmentportfolio.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "56bad9e4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('56bad9e4', __exports__)) {
    api.reload('56bad9e4', __exports__)
  }
  
  module.hot.accept("./InvEstmentportfolio.vue?vue&type=template&id=56bad9e4", () => {
    api.rerender('56bad9e4', render)
  })

}


export default __exports__